import React from "react";
import Skeleton from "react-loading-skeleton"; // Import Skeleton
import "react-loading-skeleton/dist/skeleton.css"; // Import Skeleton styles

const BlocTitleText = (props) => {
  // Show skeletons if props are not loaded (if data is not yet passed)
  if (!props?.title || !props?.text) {
    return (
      <div className="twyny-border-bottom">
       
        <h3 className="grey500">
          <Skeleton width={200} />
        </h3>
        <p className="body grey66 mt-16">
          <Skeleton count={3} />
        </p>
      </div>
    );
  }

  // When content is loaded, show the actual title and text
  return (
    <div className="twyny-border-bottom">
     
      <h3 className="grey500 mb-0">{props?.title}</h3>
      <p className="body grey66 mt-16 mb-0 break-all">{props?.text}</p>
    </div>
  );
};

export default BlocTitleText;
